import axios from 'axios';

export const authService = {
    /** Baselines */

    getBaselinesService: (params) => axios.get(`/clinical/baseline`, { auth: true, params: { ...params } }),

    createBaselineService: (body) => axios.post(`/clinical/baseline`, body, { auth: true }),

    createBaselineSessionService: (baselineId, body) => axios.post(`/clinical/baseline/${baselineId}`, body, { auth: true }),

    editBaselineService: (id, body) => axios.patch(`/clinical/baseline/${id}`, body, { auth: true }),

    editBaselineSessionService: (baselineId, sessionId, body) =>
        axios.patch(`/clinical/baseline/${baselineId}/session/${sessionId}`, body, { auth: true }),

    deleteBaselineSessionService: (baselineId, sessionId) =>
        axios.delete(`/clinical/baseline/${baselineId}/session/${sessionId}`, { auth: true }),

    /** End */
};
